import { Box, Fade, IconButton, Typography } from '@mui/material'
import { useCallback, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

/** COMPONENT */
import InputTextField from 'component/Input/InputTextField'
import TreatmentList, { CustomInputCheckbox } from 'features/finance/payment/component/popupPaymentTemp/TreatmentList'

/** CONSTANTS */
import { colors } from 'constants/theme'


import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icons } from 'constants/images'
import * as UseStyled from 'features/finance/payment/component/popupPaymentTemp/UseStyledFormPayment'

const initErrMsg = { OVER_MAX_PAID: '', OVER_BALANCE_PAID: '' }
interface PrivilegeProps {
  // no?: number
  systemConfig: {
    isUseNhso: boolean
    menu: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
    type: 'TreatmentDiscount' | 'OtherDiscount' | 'PaymentChannels' | 'VOUCHER' | 'PROMOTION'

  }
  index?: number
  title?: any
  listOrder: any
  component?: any
  patientTreatmentRightId?: number
  treatmentRight?: any
  balancePaid?: number
  maxPaid?: number
  treatmentInfo?: string
  discountHasExpired?: boolean
  disableFiled?: boolean
  disableIcon?: boolean
  advance?: boolean
  changePaid?: (val: number) => void
  onCallbackDel?: (id: number) => void
  dataPatientCase?: any

  listOrderPayment: any
  paidChannel: any
  itemChannel: any
  handleCheckBox: (type: string, id: any) => void
  handleSelectBenefit?: (treatmentRight: any) => void
  handleValueChannel: (value: any) => void
  handleValuePaidItem: (value: any, type: string, id: any) => void
  handleChangValueTreatmentRight?: (value: any) => void
  handleCheckBoxItemTreatmentRight?: (value: any, type: string, id: any) => void
}

export default function PrivilegeList(props: PrivilegeProps) {

  const { treatmentRight: treatmentRightPayment, promotion, voucher } = props.listOrderPayment
  const patientTreatmentRightId = props?.patientTreatmentRightId
  const treatmentRight = treatmentRightPayment?.[patientTreatmentRightId ?? 0]
  const isTreatmentRight = patientTreatmentRightId

  const dispatch = useDispatch()


  const [expanded, setExpanded] = useState(false)
  const [isDisabled, setIsDisabled]: any = useState({})
  const [isChecked, setIsChecked]: any = useState({})
  const [errMsg, setErrMsg] = useState({ ...initErrMsg })


  const renderValue = useCallback(() => {
    let amountPaid = props.paidChannel?.amountPaid || 0

    if (isTreatmentRight) {
      if (props.systemConfig.type === 'PROMOTION') {
        return Number(promotion?.promotionBranchId) === Number(patientTreatmentRightId) ? promotion?.amountPaid || 0 : 0
      } else if (props.systemConfig.type === 'VOUCHER') {
        return Number(voucher?.voucherListId) === Number(patientTreatmentRightId) ? voucher?.amountPaid || 0 : 0
      } else if (treatmentRight?.amountPaid !== undefined) amountPaid = treatmentRight?.amountPaid
      else amountPaid = 0
    }
    return amountPaid
  }, [props.paidChannel, props.listOrderPayment?.treatmentRight?.[props?.patientTreatmentRightId ?? 0], props.listOrderPayment?.promotion])


  const disabledInput = useMemo(() => {

    let disabled = true

    if (isTreatmentRight) {

      if (props.systemConfig.menu === 'EDIT_PAYMENT' && props.systemConfig.type !== 'TreatmentDiscount') return true
      else if (props.systemConfig.type === 'PROMOTION') {
        disabled = Number(promotion?.promotionBranchId) === Number(patientTreatmentRightId) ? promotion?.disabledInput : true
      } else if (props.systemConfig.type === 'VOUCHER') {
        disabled = Number(voucher?.voucherListId) === Number(patientTreatmentRightId) ? voucher?.disabledInput : true
      } else {
        disabled = treatmentRight?.disabledInput || true
      }
    }
    else if (props.paidChannel?.disabledInput !== undefined && !isTreatmentRight) disabled = props.paidChannel?.disabledInput

    return disabled
  },
    [props.paidChannel?.disabledInput, props.listOrderPayment?.treatmentRight?.[props?.patientTreatmentRightId ?? 0]]
  )
  const treatmentRightSelected = useMemo(() => {
    if (isTreatmentRight) {
      if (props.systemConfig.type === 'PROMOTION') {
        return promotion?.promotionBranchId === patientTreatmentRightId ? promotion?.checked || false : false
      } else if (props.systemConfig.type === 'VOUCHER') {
        return voucher?.voucherListId === patientTreatmentRightId ? voucher?.checked || false : false
      } else {
        return treatmentRight?.checked || false
      }
    }
    return false
  },
    [
      // props.listOrderPayment?.voucher,
      props.listOrderPayment?.promotion, props.listOrderPayment?.treatmentRight?.[props?.patientTreatmentRightId ?? 0]
    ]
  )

  const disabledChecked = useMemo(() => {
    if (isTreatmentRight && props.systemConfig.menu === 'EDIT_PAYMENT' && props.systemConfig.type !== 'TreatmentDiscount') return true

    else if (props.systemConfig.type === 'PROMOTION')
      return promotion?.promotionBranchId === patientTreatmentRightId ? promotion?.disabledChecked || false : false
    else if (props.systemConfig.type === 'VOUCHER')
      return voucher?.voucherListId === patientTreatmentRightId ? voucher?.disabledChecked || false : false
    else
      return treatmentRight?.disabledChecked || false

  },
    [props.listOrderPayment?.promotion, props.listOrderPayment?.treatmentRight?.[props?.patientTreatmentRightId ?? 0]]
  )

  const handleValueChannel = useCallback((e) => props.handleValueChannel(e), [props.handleValueChannel])

  return (

    <>
      <Box className="d-flex align-items-start mt-3 pr-md-2 pr-xl-3">
        <Box className={`d-flex w-100 ${props.systemConfig.type !== 'TreatmentDiscount' ? 'pt-2' : ''}`} sx={{ paddingLeft: '2px' }}>
          {((props.systemConfig.type === 'TreatmentDiscount' || props.systemConfig.type === 'PROMOTION' || props.systemConfig.type === 'VOUCHER') && (
            <CustomInputCheckbox
              label={props.title}
              info={props.treatmentInfo}
              checked={props.patientTreatmentRightId ? treatmentRightSelected : props.systemConfig.isUseNhso ? true : false}
              onChange={(e) => props.handleSelectBenefit?.(props.treatmentRight)}
              disabled={disabledChecked}

            />
          )) || (
              <>
                {(typeof props.title === 'string' && (
                  <Typography className="pr-2" sx={{ fontWeight: 500 }}>
                    {props.title}
                  </Typography>
                )) ||
                  props.title}
              </>
            )}
        </Box>
        <UseStyled.CustomField>
          {props.systemConfig.type === 'TreatmentDiscount' || props.systemConfig.type === 'PROMOTION' || props.systemConfig.type === 'VOUCHER' ? (
            <>
              <InputTextField
                disabled={disabledInput}
                value={renderValue()}
                type='number'
                financeText
                hideControl
                onchange={(e) => props?.handleChangValueTreatmentRight?.(e.target.value)}
                inputTextAlign="right"
              />
            </>
          ) : (
            <>
              <InputTextField
                disabled={disabledInput}
                value={renderValue()}
                type='number'
                financeText
                hideControl
                onchange={(e) => { handleValueChannel(e) }}
                helperText={errMsg.OVER_BALANCE_PAID || errMsg.OVER_MAX_PAID || ''}
                inputTextAlign="right"
              />
            </>
          )}
          {props.disableIcon ? <></> :
            <IconButton
              disableRipple
              onClick={() => {
                if (props?.patientTreatmentRightId) {
                  if (treatmentRightSelected) setExpanded(!expanded)
                } else setExpanded(!expanded)
              }}
              className={`icon-expanded ${expanded ? 'isExpanded' : ''} ${props?.patientTreatmentRightId ? (isChecked[props?.patientTreatmentRightId] && '') || 'disabled pe-none' : ''} ${props.discountHasExpired ? 'disabled pe-none' : ''} mt-1`}
            >
              <FontAwesomeIcon icon={faCaretDown} style={{ color: colors.textPrimary, fontSize: 20 }} />
            </IconButton>
          }

        </UseStyled.CustomField>
        {props.systemConfig.type === 'VOUCHER' && props.listOrderPayment?.voucher?.voucherListId &&
          <Box>
            <Box
              component={'span'}
              color={colors.statusInactive}
              marginLeft={'8px'}
              onClick={() => {
                if (props?.patientTreatmentRightId && props?.onCallbackDel) {
                  props.onCallbackDel(props?.patientTreatmentRightId)
                }
              }}
              sx={{
                pointerEvents: props.systemConfig.menu !== 'EDIT_PAYMENT' ? '' : 'none',
                cursor: props.systemConfig.menu !== 'EDIT_PAYMENT' ? 'pointer' : '',
                filter: props.systemConfig.menu !== 'EDIT_PAYMENT' ? '' : 'grayscale(1)',
                opacity: props.systemConfig.menu !== 'EDIT_PAYMENT' ? '' : '0.6',
              }}
            >
              <IconButton >
                <img src={icons.btnTrash} alt="trash" />
              </IconButton>
            </Box>

          </Box>
        }
      </Box>
      {!props.systemConfig.isUseNhso &&
        <Fade in={expanded
          //  || onRenderCheckBox(isChecked[props?.patientTreatmentRightId || 0], 'isCheck')
        }>
          {treatmentRightSelected ? (<>
            <Box className={`${expanded || treatmentRightSelected ? 'd-block' : 'd-none'} pl-4 pr-md-2 pr-xl-3`}>
              <TreatmentList
                systemConfig={props.systemConfig}
                itemChannel={props.itemChannel || {}}
                listOrder={props.listOrder}
                listOrderPayment={props.listOrderPayment}
                handleCheckBox={(type: string, id: any) => {
                  if (props?.patientTreatmentRightId) props.handleCheckBoxItemTreatmentRight?.(props?.patientTreatmentRightId, type, id)
                  else props.handleCheckBox(type, id)
                }}
                handleValuePaidItem={props.handleValuePaidItem}
                patientTreatmentRightId={props?.patientTreatmentRightId}
              />
            </Box >
          </>) : (<div>
            <Box className={`${expanded || treatmentRightSelected ? 'd-block' : 'd-none'} pl-4 pr-md-2 pr-xl-3`}>
              <TreatmentList
                systemConfig={props.systemConfig}
                itemChannel={props.itemChannel || {}}
                listOrder={props.listOrder}
                listOrderPayment={props.listOrderPayment}
                handleCheckBox={(type: string, id: any) => {
                  if (props?.patientTreatmentRightId) props.handleCheckBoxItemTreatmentRight?.(props?.patientTreatmentRightId, type, id)
                  else props.handleCheckBox(type, id)
                }}
                handleValuePaidItem={props.handleValuePaidItem}
                patientTreatmentRightId={props?.patientTreatmentRightId}
              />
            </Box >
          </div>)}


        </Fade >
      }
    </>
  )
}

// export default memo(PrivilegeList)
